import type {
    SignalManagementModalProps,
} from "../../components/modals/SignalsManagementModal/SignalsManagementModal";
import SignalsManagementModal from "../../components/modals/SignalsManagementModal/SignalsManagementModal";
import type SignalFilters from "../../models/core/SignalFilters";
import type SignalType from "../../models/core/SignalType";
import type UISignal from "../../models/view/UISignal";
import trackingService from "../../services/tracking/trackingService";

const SignalsManagementModalTracked = (props: SignalManagementModalProps) => {
    function handleSignalCreateTracked(signalType: SignalType) {
        trackingService.management.trackCreateSignalClick("signals management popup", signalType);
        props.onSignalCreate(signalType);
    }

    function handleSignalEdit<F extends SignalFilters>(uiSignal: Readonly<UISignal<F>>) {
        trackingService.management.trackEditSignalClick(uiSignal);
        props.onSignalEdit(uiSignal);
    }

    function handleSignalDelete<F extends SignalFilters>(uiSignal: UISignal<F>) {
        trackingService.management.trackDeleteSignalClick(uiSignal);
        props.onSignalDelete(uiSignal);
    }

    function handleSignalTypeSelect(signalType: SignalType) {
        trackingService.management.trackSignalTypeClick(signalType);
        props.onSignalTypeSelect?.(signalType);
    }

    return (
        <SignalsManagementModal
            {...props}
            onSignalCreate={handleSignalCreateTracked}
            onSignalEdit={handleSignalEdit}
            onSignalDelete={handleSignalDelete}
            onSignalTypeSelect={handleSignalTypeSelect}
        />
    );
};

export default SignalsManagementModalTracked;
